<div class="options-container btn-group-vertical">
  <div class="button-container text-center col-12 col-md-6 col-lg-4" *ngFor="let option of options">
    <button id="option.id" [style.background-color]="remoteConfigService.config.primary_color" type="button" class="btn btn-secondary col-10 col-md-12 cursor-pointer" (click)="selectOption(option)" >{{option.name}}</button>
  </div>
</div>